import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import Container from '../../../UI/Container/Container'
import _ from 'lodash'

type Props = {
  textKey: string
  image: string
  reverse?: boolean
}

const Split: React.FC<Props> = ({ reverse, textKey, image }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className={`relative py-12 md:py-32 ${reverse ? 'bg-beige' : ''}`}>
      <Container>
        <div className={`flex gap-10 md:gap-32 items-center ${reverse ? 'flex-row-reverse' : 'flex-row'}`}>
          <div className="w-8/12">
            {_.get(t, `${textKey}.headline`).map((text, i) => (
              <div key={i} className="uppercase text-[0.80rem] md:text-xl font-bold md:leading-[2.25rem]">
                {text}
              </div>
            ))}
            <div className="text-2xs md:text-lg mb-5 md:mb-10">{_.get(t, `${textKey}.subline`)}</div>
            {_.get(t, `${textKey}.text`).map((text, i) => (
              <div className="text-2xs md:text-lg" key={i} dangerouslySetInnerHTML={{ __html: text }} />
            ))}
          </div>
          <div className="flex w-4/12">
            <img src={image} className="w-full" alt="" />
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Split
